/**
 * §1.5 shared header and §1.6 shared footer — identical on every screen.
 *
 * Markup and class names match app/public/index.html exactly. The stylesheet
 * is shared between both frontends, so any divergence here shows up as a
 * visual difference with no corresponding CSS change to explain it.
 *
 * The header's right-hand slot is a single mutable region in the vanilla app
 * (`#header-right`). Here it is a prop, so a screen states what belongs there
 * rather than reaching across the DOM to set it.
 */

export function Header({ right }) {
  return (
    <header className="site-header">
      <div className="header-bar">
        <div className="header-left">
          <img className="header-logo" src="/assets/failte-ireland-logo.png" alt="Fáilte Ireland" />
          <div className="header-divider" />
          <div>
            <div className="wordmark">FIDMAT</div>
            <div className="brand-sub">Digital &amp; AI Maturity Assessment Tool</div>
          </div>
        </div>
        {right ?? <span />}
      </div>
    </header>
  );
}

/** The reference-code pill, and the staff variant of the same slot. */
export const RefPill = ({ children }) => <span className="ref-pill">{children}</span>;

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-bar">
        <div className="footer-wordmark">Fáilte Ireland</div>
        <div className="footer-centre">
          Digital &amp; AI Maturity Assessment Tool — developed in partnership with the
          Data2Sustain EDIH programme
        </div>
        {/* href="#" as in the legacy shell: these are placeholders, and
            inventing targets here would imply pages that do not exist. */}
        <div className="footer-links">
          <a href="#">Privacy</a>
          <a href="#">Contact</a>
        </div>
      </div>
    </footer>
  );
}
